export default {
    namespaced:true,
    actions:{
        async getCollectionList(context,params){//获取收藏列表
            let { data } = await axios.post('job/api/my_collection/list',params);
            return data;
        }
    }
}